import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  display: flex;
  position: absolute;
  background-color: #fff;
  flex: 1;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 3;
  padding: 10px 0;
  flex-direction: column;
  justify-content: space-around;

  ${mediaMaxWidth.phone`
    height: ${(props) => props.field === "user" && "414px"};
    top: ${(props) => props.field === "user" && "-165px"};
  `}
`;

export const Text = styled.div`
  text-align: center;

  span {
    font-weight: 700;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;

  button {
    margin: 0 10px;
  }
`;
